module.exports = __webpack_public_path__ + "img/9791186771228.1269a953.jpg";